// extracted by mini-css-extract-plugin
export default {"modal_content":"PhysicalQrModal_modal_content__QVMPM","btn_close":"PhysicalQrModal_btn_close__cDBi3"};